export default __webpack_public_path__ + "static/media/normal-available_loan.a1f91275.jpg";